import type { GetTokenSilentlyOptions } from "@auth0/auth0-react";
import { useCallback } from "react";
import { useToken } from "../../../server/auth/use-token";
import { ImagesService } from "../../../server/cloudflare/images-service";
import { uuidv4 } from "../../../utils/uuid";

export function useUploadImage(): (
  file?: { attachments?: File[] },
  done?: (result: { progress: number; url?: string }) => void,
) => void {
  const getToken = useToken();

  return useCallback(
    (
      file?: { attachments?: File[] },
      done?: (result: { progress: number; url?: string }) => void,
    ) => {
      void saveImage(getToken, file, done);
    },
    [getToken],
  );
}

async function saveImage(
  getToken: (options?: GetTokenSilentlyOptions) => Promise<string>,
  file?: { attachments?: File[] },
  done?: (result: { progress: number; url?: string }) => void,
): Promise<void> {
  const uploadFile = file?.attachments?.[0];
  if (!uploadFile) return;

  done?.({ progress: 10 });
  const name = uuidv4();
  const imagesService = new ImagesService();
  const result = await imagesService.upload(uploadFile, name, await getToken());
  if (!result.success || !result.url) return;
  done?.({ progress: 100, url: result.url });
}
